import { Tonality } from "@mui/icons-material";
import { Divider, Skeleton, Stack } from "@mui/material";
import {
  ItemProperty,
  TaskItemDueDateProperty,
  TaskItemNoteProperty,
  TaskItemOwnershipProperty,
  TaskItemStatusPicker,
  TaskItemSubtasksProperty,
  TaskItemTeamProperty,
} from "src/components";
import { DEFAULT_TASK_ITEM_STATUS, TaskItemPropertyType } from "src/constants";
import { TaskItemDetailDto, UserDto } from "src/http";
import { ITeamSummary } from "src/models";

interface IProps {
  taskItem: TaskItemDetailDto | undefined;
  isLoading: boolean;
  propertyVisibility?: {
    [key in TaskItemPropertyType]?: boolean;
  };
  onTeamChanged?: (selectedTeam: ITeamSummary | null) => void;
  onOwnershipChanged?: (taskItemGuid: string, taskItemDescription: string, removedOwners: UserDto[]) => void;
  onSubtaskClicked?: (taskItemGuid: string) => void;
}

const TaskItemProperties = (props: IProps) => {
  return (
    <>
      {props.isLoading && (
        <Stack
          spacing={0.5}
          sx={{ px: { xs: 0.5, sm: 1 }, py: 0.5 }}
          divider={<Divider flexItem sx={{ borderStyle: "dashed" }} />}
        >
          <Skeleton width={"80%"} />
          <Skeleton width={"80%"} />
          <Skeleton width={"80%"} />
        </Stack>
      )}
      {!props.isLoading && props.taskItem && (
        <Stack
          spacing={0.5}
          sx={{ px: { xs: 0.5, sm: 1 }, py: 0.5 }}
          divider={<Divider flexItem sx={{ borderStyle: "dashed" }} />}
        >
          <TaskItemTeamProperty taskItem={props.taskItem} onTeamChanged={props.onTeamChanged} />

          {(!props.propertyVisibility || props.propertyVisibility?.status) && (
            <ItemProperty labelIcon={<Tonality />} label="Status" rowLayoutOnSmallScreens>
              <TaskItemStatusPicker
                variant="select"
                taskItemGuid={props.taskItem.guid}
                status={props.taskItem.currentStatus ?? DEFAULT_TASK_ITEM_STATUS}
                disabled={!props.taskItem.userCanEdit}
                teamSlug={props.taskItem.team?.slug}
                ownerUserGuids={props.taskItem.owners.map((x) => x.user.userId)}
              />
            </ItemProperty>
          )}

          {(!props.propertyVisibility || props.propertyVisibility?.ownership) && (
            <TaskItemOwnershipProperty taskItem={props.taskItem} onChanged={props.onOwnershipChanged} />
          )}

          {(!props.propertyVisibility || props.propertyVisibility?.notes) && (
            <TaskItemNoteProperty taskItem={props.taskItem} />
          )}

          {(!props.propertyVisibility || props.propertyVisibility.dueDate) && (
            <TaskItemDueDateProperty taskItem={props.taskItem} />
          )}

          {(!props.propertyVisibility || props.propertyVisibility.subtasks) && (
            <TaskItemSubtasksProperty taskItem={props.taskItem} onClick={props.onSubtaskClicked} />
          )}
        </Stack>
      )}
    </>
  );
};

export { TaskItemProperties };
